<template>
    <div class="full">
        <Tree  :data="resTree"
                show-checkbox
                @on-check-change="onSelect"
               :check-directly="true"
                ref="res_tree"
               style="max-height: 500px;overflow-y: auto;"
                class="form-item-container"></Tree>
    </div>
</template>

<script>
    export default {
        name: "auth-checker",
        mixin:[],
        props: {
            resTree: Array,
            checked: Array
        },
        methods: {
            onSelect (nodes,currentNode) { // 修改样式的同时  ，修改选中项 ,子项取消再次选中样式不变化
                let arr = this.$refs.res_tree.getCheckedAndIndeterminateNodes().map(node =>(node.res_key));
                this.$emit('on-checked', arr ,currentNode);
            },
        },
    }
</script>

<style scoped>

</style>